/* Fidelavo · oferta de la cinta: color + tarjeta de pack → variante, cantidad y precio */
(function () {
  function dinero(cents, formato) {
    var n = (cents / 100);
    var con = function (dec, mil, sep) { var p = n.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil); return p.join(sep); };
    return (formato || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, t) {
      if (t === 'amount_with_comma_separator') return con(2, '.', ',');
      if (t === 'amount_no_decimals') return con(0, ',', '.');
      if (t === 'amount_no_decimals_with_comma_separator') return con(0, '.', ',');
      if (t === 'amount_with_apostrophe_separator') return con(2, "'", '.');
      return con(2, ',', '.');
    });
  }
  function init(ctx) {
    (ctx || document).querySelectorAll('[data-fv-oferta]').forEach(function (of) {
      if (of.dataset.fvIniciado) return; of.dataset.fvIniciado = '1';
      var form = of.closest('form'); if (!form) return;
      var tabla = {}; (of.querySelector('[data-fv-tabla]').textContent || '').trim().split(';').forEach(function (g) { var p = g.split(':'); if (p.length < 2) return; var o = {}; p[1].split(',').forEach(function (x) { var kv = x.split('='); if (kv.length === 2) o[kv[0].trim()] = kv[1].trim(); }); tabla[p[0].trim()] = o; });
      var medios = {}; try { medios = JSON.parse(of.querySelector('[data-fv-medios]').textContent); } catch (e) {}
      var colorPrevio = null;
      var idInput = form.querySelector('input[name="id"]');
      var qty = of.querySelector('[data-fv-cantidad]');
      var nombre = of.querySelector('[data-fv-color-nombre]');
      var seccion = of.closest('.mt-producto') || document;
      function sync() {
        var c = of.querySelector('.fv-colores input:checked');
        var p = of.querySelector('.fv-packs input:checked');
        if (!c || !p) return;
        var id = (tabla[c.value] || {})[p.value];
        if (id && idInput) idInput.value = id;
        if (qty) qty.value = p.dataset.cantidad || '1';
        if (nombre) nombre.textContent = c.dataset.nombre || '';
        var txt = dinero(parseInt(p.dataset.precio, 10), of.dataset.money);
        seccion.querySelectorAll('[data-mt-precio]').forEach(function (el) { el.textContent = txt; });
        document.querySelectorAll('.mt-barra [data-mt-precio]').forEach(function (el) { el.textContent = txt; });
        of.querySelectorAll('.fv-pack').forEach(function (l) { l.classList.toggle('is-activa', l.contains(p)); });
        // al cambiar de color, la galería muestra la foto de ese color
        if (colorPrevio !== null && colorPrevio !== c.value && id && medios[id]) {
          var imgs = Array.prototype.slice.call(seccion.querySelectorAll('.mt-galeria__principal img[data-media-id]'));
          var i = imgs.findIndex(function (im) { return String(im.dataset.mediaId) === String(medios[id]); });
          var minis = seccion.querySelectorAll('.mt-galeria__miniaturas button');
          if (i >= 0 && minis[i]) minis[i].click();
        }
        colorPrevio = c.value;
      }
      of.addEventListener('change', sync);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
